const contactForm = document.querySelector('.wpcf7');
if (contactForm) {
    const submitButton = contactForm.querySelector('.submit-btn');
    const icon = '<svg viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" class="single-document__button-icon"><g clip-path="url(#clip0_2476_13290)"><path d="M22.1525 3.55321L11.1772 21.0044L9.50686 12.4078L2.00002 7.89795L22.1525 3.55321Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.45557 12.4436L22.1524 3.55321" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_2476_13290"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>'

    // Gabarit Contact : bouton sans icône (maquette)
    if (submitButton && !contactForm.closest('.frge-contact')) {
        submitButton.innerHTML = icon + submitButton.innerHTML;
    }

    //On récupère le titre du document (uniquement sur les pages single document)
    const documentTitle = document.querySelector('.single-document__title');
    const yourMessage = document.querySelector('.frge-message');
    if (documentTitle && yourMessage) {
        const title = documentTitle.innerText.trim();
        //On alimente le champs votre message avec le titre du document
        yourMessage.value = `Bonjour,
Pourriez-vous m’envoyer SVP la publication "${title}" ?
Cordialement.`
    }
}